enum EmailStatus {
  CANCELLED = "cancelled",
  ERRORED = "errored",
  SCHEDULED = "scheduled",
  SENDING = "sending",
  SENT = "sent",
  SUBMITTED = "submitted",
}

export default EmailStatus;
